// check an object has any field that is not falsy.
// the object can have array field.
// when a field is array, check its items via recursive call.
export function hasAnyContent(obj) {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            if (Array.isArray(value)) {
                const arr = value;
                for (let i = 0; i < arr.length; i++) {
                    if (hasAnyContent(arr[i])) {
                        return true;
                    }
                }
            } else if (value) {
                return true;
            }
        }
    }

    return false;
}